import { render } from "./AiMapChatFab.vue?vue&type=template&id=4ef245f5&scoped=true"
import script from "./AiMapChatFab.vue?vue&type=script&lang=js"
export * from "./AiMapChatFab.vue?vue&type=script&lang=js"

import "./AiMapChatFab.vue?vue&type=style&index=0&id=4ef245f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef245f5"]])

export default __exports__